export default {
  _brandName: 'o-',
  createBrandName: function createBrandName() {
    return this._brandName;
  },
  setBrandName: function setBrandName(brandName) {
    if (brandName) {
      this._brandName = brandName;
    }
  }
};